import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useState } from "react";

import LutronDesignerClientProxy from "../../backend/clients/LutronDesignerClientProxy";
import Modal from "../../ui/Modal/Modal";
import srcSpinner from "../../assets/images/blue-spinner.gif";
import { useServiceWorkerContext } from "../ServiceWorkerContext/ServiceWorkerContext";
import { useToolContext } from "../ToolContext/ToolContext";

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 25px 20px;
  gap: 18px;
`;

const Heading = styled.span`
  font-size: 27px;
  font-weight: 500;
  line-height: 33px;
  letter-spacing: 0em;
  text-align: left;
`;

const SearchButton = styled.button`
  background: rgba(0, 0, 0, 0.78);
  box-shadow: 0px 0.75px 1.5px 0px rgba(0, 0, 0, 0.2);
  color: white;
  font-weight: 100;
  font-size: 12px;
  border-radius: 8px;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
`;

const SearchInput = styled.input`
  width: 300px;
  height: 20px;
  display: flex;
`;

const CreateNew = styled.button`
  background: rgba(0, 0, 0, 0.78);
  box-shadow: 0px 0.75px 1.5px 0px rgba(0, 0, 0, 0.2);
  color: white;
  font-weight: 100;
  font-size: 12px;
  border-radius: 8px;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  margin-left: auto;

  :disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

const Loader = styled.img`
  width: 100px;
  height: 100px;
`;

const Center = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

type Props = {
  onSearchPlaces: (query: string) => void;
};

const Filter = ({ onSearchPlaces }: Props): JSX.Element => {
  const { t } = useTranslation();
  const context = useToolContext();
  const sw = useServiceWorkerContext();

  const [searchValue, setSearchValue] = useState("");

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const createNewProject = () => {
    setIsModalOpen(true);
    LutronDesignerClientProxy.createArtifactRequest(sw.waitForInstalled);
  };

  return (
    <FilterContainer>
      {isModalOpen && (
        <Modal>
          <Center data-testid="loader-modal">
            <Loader src={srcSpinner} alt={t("loading")} />
          </Center>
        </Modal>
      )}
      <Heading>{t("filter.headline")}</Heading>
      <SearchInput
        type="text"
        data-testid="input-search-place"
        placeholder={t("filter.search_placeholder")}
        onChange={(e) => setSearchValue(e.target.value)}
        value={searchValue}
      />
      <SearchButton
        data-testid="btn-search-place"
        onClick={() => onSearchPlaces(searchValue)}
      >
        {t("filter.actions.search_places")}
      </SearchButton>
      <CreateNew disabled={context.isOffline} onClick={createNewProject}>
        {t("actions.create_new_project")}
      </CreateNew>
    </FilterContainer>
  );
};

export default Filter;
